/*
// afterpay code
document.addEventListener('DOMContentLoaded', function () {
    var afterPayContainer = document.getElementById('afterpay-container');

    if (!afterPayContainer) {
        return;
    }

    var afterPayCustomCSS = `
        :host {
            margin: 0;
        }

        .afterpay-paragraph {
            font-size: 12px !important;
            line-height: 12px !important;
            font-family: Verdana, Arial, Helvetica, sans-serif !important;
            font-weight: 400;
            color: #000;
            margin-top: 0;
            font-smooth: auto;
            -webkit-font-smoothing: auto;
        }

        @media only screen and (max-width: 767px) {
            .afterpay-paragraph {
                font-size: 11px !important;
            }
        }

        @media only screen and (min-width: 768px) {
            .afterpay-paragraph {
                font-size: 12px !important;
                line-height: 14px !important;
            }
        }

        .afterpay-logo {
            padding-top: 0;
            width: auto !important;
            margin: 0;
            height: 20px;
            min-height: 12px !important;
            cursor: pointer;
            position: relative;
        }

        .payment-amount + span {
            padding-right: 0;
        }

        .afterpay-logo::after {
            content: '.';
            display: inline;
            vertical-align: 6px;
        }

        .afterpay-logo svg {
            --logo-badge-width: 64px;
            line-height: 12px;
        }

        @media only screen and (min-width: 768px) {
            .afterpay-logo svg {
                line-height: 16px;
            }
        }

        .afterpay-logo-link {
            position: relative;
        }

        #logo-link {
            font-family: inherit;
            font-size: inherit;
        }

        .afterpay-link slot {
            display: none;
        }

        .afterpay-link template::after {
            content: 'Learn more';
            text-decoration: underline;
        }

        .c-afterpay .afterpay-logo.brand-afterpay svg {
            max-width: 80px;
        }
    `;

    var injectCustomCSS = function (el, customCSS) {
        if (el.shadowRoot) {
            var styleEl = document.createElement('style');
            styleEl.innerHTML = customCSS;
            el.shadowRoot.appendChild(styleEl);
        }
    };

    var observer = new MutationObserver(function (mutations, observer) {
        var afterPayEls = afterPayContainer.querySelectorAll('afterpay-placement');
        afterPayEls.forEach(function (el) {
            if (el.shadowRoot && !el.shadowRoot.querySelector('style[data-injected="true"]')) {
                injectCustomCSS(el, afterPayCustomCSS);
            }
        });
    });

    observer.observe(afterPayContainer, { childList: true, subtree: true });

    // Initial check in case the elements are already present
    var afterPayEls = afterPayContainer.querySelectorAll('afterpay-placement');
    afterPayEls.forEach(function (el) {
        if (el.shadowRoot) {
            injectCustomCSS(el, afterPayCustomCSS);
        }
    });
});
*/


// paypal code
document.addEventListener('DOMContentLoaded', function () {
    var paypalContainer = document.getElementById('paypal-container');

    if (!paypalContainer) {
        return;
    }

    // Function to inject the PayPal SDK
    var addPayPalSdk = function () {
        return new Promise(function (resolve) {
            if (window.paypal) {
                resolve();
            } else {
                var script = document.createElement('script');
                script.src = 'https://www.paypal.com/sdk/js?client-id=AQ1AFTPlzkwghvA9bta_K3hSCFIW_XC3GJ127Aq2wID5Q5wQMaiZL56577PKwFlnDsBlZtpvq9Twn6hz&components=messages,buttons';
                document.body.prepend(script);

                // Check when PayPal SDK is loaded
                var interval = setInterval(function () {
                    if (window.paypal) {
                        clearInterval(interval);
                        resolve();
                    }
                }, 500);
            }
        });
    };

    // Function to display PayPal message
    var renderPayPalMessage = function () {
        window.paypal.Messages({
            placement: 'product',
            buyerCountry: window.payment_widgets?.data_country, // Use Shopify's localization country directly
            amount: window.payment_widgets?.data_amount,
            currency: window.payment_widgets?.data_currency_name, // Use Shopify's localization currency directly
            style: {
                layout: 'text',
                logo: {
                    type: 'inline'
                },
                text: {
                    color: 'monochrome',
                    align: 'left',
                    fontFamily: 'Verdana',
                    size: window.innerWidth < 768 ? 11 : 12
                }
            },
            onRender: function () {
                // Handle iframe visibility and customization after rendering
                var iframe = document.querySelector('.paypal-placement iframe[data-height]');
                if (iframe) {
                    iframe.style.opacity = '1';
                }
            }
        }).render('.paypal-placement');
    };

    // Initialize PayPal SDK and render messages
    addPayPalSdk().then(function () {
        renderPayPalMessage();
    });
});